import React, { useContext, useEffect, useReducer, useState } from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import useHelps from "../hooks/useHelps";
import PluginSidebarItems from "./PluginSidebarItems";
import TermsOfUseModal from "../components/TermsOfUseModal";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ListSubheader from "@material-ui/core/ListSubheader";
import Divider from "@material-ui/core/Divider";
import Avatar from "@material-ui/core/Avatar";
import Badge from "@material-ui/core/Badge";
import Collapse from "@material-ui/core/Collapse";
import List from "@material-ui/core/List";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";

import DashboardOutlinedIcon from "@material-ui/icons/DashboardOutlined";
import EqualizerIcon from "@material-ui/icons/Equalizer";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import SyncAltIcon from "@material-ui/icons/SyncAlt";
import SettingsOutlinedIcon from "@material-ui/icons/SettingsOutlined";
import PeopleAltOutlinedIcon from "@material-ui/icons/PeopleAltOutlined";
import ContactPhoneOutlinedIcon from "@material-ui/icons/ContactPhoneOutlined";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import AccountTreeOutlinedIcon from "@material-ui/icons/AccountTreeOutlined";
import FlashOnIcon from "@material-ui/icons/FlashOn";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import CodeRoundedIcon from "@material-ui/icons/CodeRounded";
import ViewKanban from "@mui/icons-material/ViewKanban";
import Schedule from "@material-ui/icons/Schedule";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import HistoryToggleOffIcon from '@mui/icons-material/HistoryToggleOff';
import EventAvailableIcon from "@material-ui/icons/EventAvailable";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import CakeIcon from "@material-ui/icons/Cake";
import PeopleIcon from "@material-ui/icons/People";
import ListIcon from "@material-ui/icons/ListAlt";
import AnnouncementIcon from "@material-ui/icons/Announcement";
import ForumIcon from "@material-ui/icons/Forum";
import LocalAtmIcon from "@material-ui/icons/LocalAtm";
import {
  AttachFile,
  Dashboard,
  Description,
  GridOn,
  PhonelinkSetup,
  Link as LinkIcon,
  Language as LanguageIcon,
  Assessment as AssessmentIcon,
  AccountBalance as AccountBalanceIcon,
  ShoppingCart as ShoppingCartIcon,
  People as PeopleExtIcon,
  Storage as StorageIcon,
  Cloud as CloudIcon,
  Code as CodeIcon,
  Build as BuildIcon,
  Info as InfoIcon,
  Visibility as VisibilityIcon,
  Work as WorkIcon,
  School as SchoolIcon,
  Home as HomeIcon,
  Favorite as FavoriteIcon,
  Star as StarIcon,
  Bookmark as BookmarkIcon,
  Folder as FolderIcon,
  AccountCircle as AccountCircleIcon,
  Email as EmailIcon,
  Phone as PhoneIcon,
  Chat as ChatIcon,
  Notifications as NotificationsIcon,
  Search as SearchIcon,
  // Ícones adicionais válidos para Material-UI v4
  Business as BusinessIconExt,
  LocalShipping as LocalShippingIcon,
  LocalAtm as LocalAtmIconExt,
  CreditCard as CreditCardIcon,
  Receipt as ReceiptIcon,
  AttachMoney as AttachMoneyIcon,
  TrendingUp as TrendingUpIcon,
  BarChart as BarChartIcon,
  PieChart as PieChartIcon,
  Timeline as TimelineIcon,
  InsertChart as InsertChartIcon,
  ShowChart as ShowChartIcon,
  EventNote as EventNoteIcon,
  Event as EventIcon,
  CalendarToday as CalendarTodayIcon,
  Alarm as AlarmIcon,
  Timer as TimerIcon,
  Map as MapIcon,
  Place as PlaceIcon,
  LocationOn as LocationOnIcon,
  Navigation as NavigationIcon,
  DirectionsCar as DirectionsCarIcon,
  Flight as FlightIcon,
  LocalHospital as LocalHospitalIcon,
  LocalPharmacy as LocalPharmacyIcon,
  Healing as HealingIcon,
  FitnessCenter as FitnessCenterIcon,
  Restaurant as RestaurantIcon,
  LocalCafe as LocalCafeIcon,
  Fastfood as FastfoodIcon,
  ShoppingBasket as ShoppingBasketIcon,
  Store as StoreIcon,
  Storefront as StorefrontIcon,
  LocalMall as LocalMallIcon,
  CardGiftcard as CardGiftcardIcon,
  Loyalty as LoyaltyIcon,
  Category as CategoryIcon,
  Assignment as AssignmentIcon,
  AssignmentTurnedIn as AssignmentTurnedInIcon,
  Gavel as GavelIcon,
  Policy as PolicyIcon,
  Security as SecurityIcon,
  Lock as LockIcon,
  VpnKey as VpnKeyIcon,
  VerifiedUser as VerifiedUserIcon,
  Group as GroupIcon,
  PersonAdd as PersonAddIcon,
  ContactMail as ContactMailIcon,
  ContactPhone as ContactPhoneIcon,
  Contacts as ContactsIcon,
  Headset as HeadsetIcon,
  HeadsetMic as HeadsetMicIcon,
  Announcement as AnnouncementIconExt,
  Report as ReportIcon,
  Error as ErrorIcon,
  Warning as WarningIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  Block as BlockIcon,
  ThumbUp as ThumbUpIcon,
  ThumbDown as ThumbDownIcon,
  Grade as GradeIcon,
  EmojiEvents as EmojiEventsIcon,
  DeveloperMode as DeveloperModeIcon,
  BugReport as BugReportIcon,
  Extension as ExtensionIcon,
  Widgets as WidgetsIcon,
  Apps as AppsIcon,
  Memory as MemoryIcon,
  Computer as ComputerIcon,
  Laptop as LaptopIcon,
  PhoneAndroid as PhoneAndroidIcon,
  Tablet as TabletIcon,
  Watch as WatchIcon,
  Tv as TvIcon,
  Print as PrintIcon,
  Router as RouterIcon,
  Wifi as WifiIcon,
  Bluetooth as BluetoothIcon,
  CloudUpload as CloudUploadIcon,
  CloudDownload as CloudDownloadIcon,
  CloudDone as CloudDoneIcon,
  Backup as BackupIcon,
  Save as SaveIcon,
  GetApp as GetAppIcon,
  Publish as PublishIcon,
  FileCopy as FileCopyIcon,
  FolderOpen as FolderOpenIcon,
  FolderShared as FolderSharedIcon,
  CreateNewFolder as CreateNewFolderIcon,
  Image as ImageIcon,
  PhotoCamera as PhotoCameraIcon,
  Videocam as VideocamIcon,
  Mic as MicIcon,
  MusicNote as MusicNoteIcon,
  Movie as MovieIcon,
  PlayArrow as PlayArrowIcon,
  VolumeUp as VolumeUpIcon,
  WbSunny as WbSunnyIcon,
  NightsStay as NightsStayIcon,
  Brightness4 as Brightness4Icon,
  Palette as PaletteIcon,
  Brush as BrushIcon,
  ColorLens as ColorLensIcon,
  FormatPaint as FormatPaintIcon,
  TextFields as TextFieldsIcon,
  Whatshot as WhatshotIcon,
  Eco as EcoIcon,
  Nature as NatureIcon,
  Pets as PetsIcon,
  Public as PublicIcon,
  Explore as ExploreIcon,
  Flag as FlagIcon,
  Android as AndroidIcon,
  Apple as AppleIcon,
  Facebook as FacebookIcon,
  Twitter as TwitterIcon,
  Instagram as InstagramIcon,
  LinkedIn as LinkedInIcon,
  YouTube as YouTubeIcon,
  Telegram as TelegramIcon,
  GitHub as GitHubIcon,
  Dns as DnsIcon,
  TableChart as TableChartIcon,
  Sync as SyncIcon,
  Refresh as RefreshIcon,
  OpenInNew as OpenInNewIcon,
  Launch as LaunchIcon,
  ExitToApp as ExitToAppIcon,
  PowerSettingsNew as PowerSettingsNewIcon,
  MoreVert as MoreVertIcon,
  MoreHoriz as MoreHorizIcon,
  FilterList as FilterListIcon,
  Sort as SortIcon,
  List as ListIconMUI,
  FormatListBulleted as FormatListBulletedIcon,
  PlaylistAdd as PlaylistAddIcon,
  Queue as QueueIcon,
  ViewModule as ViewModuleIcon,
  ViewList as ViewListIcon,
  ViewQuilt as ViewQuiltIcon,
  History as HistoryIcon,
  Update as UpdateIcon,
  AccessTime as AccessTimeIcon,
  Today as TodayIcon,
  DateRange as DateRangeIcon,
  Pause as PauseIcon,
  Stop as StopIcon,
  SkipNext as SkipNextIcon,
  SkipPrevious as SkipPreviousIcon,
  Restore as RestoreIcon,
  SaveAlt as SaveAltIcon,
  Cast as CastIcon,
  Mouse as MouseIcon,
  Keyboard as KeyboardIcon,
} from "@material-ui/icons";

import { WhatsAppsContext } from "../context/WhatsApp/WhatsAppsContext";
import { AuthContext } from "../context/Auth/AuthContext";
import { useActiveMenu } from "../context/ActiveMenuContext";

import { Can } from "../components/Can";
import NewBadge from "../components/NewBadge";

import { isArray } from "lodash";
import api from "../services/api";
import toastError from "../errors/toastError";
import usePlans from "../hooks/usePlans";
import useVersion from "../hooks/useVersion";
import { i18n } from "../translate/i18n";
import { Campaign, ShapeLine, Webhook } from "@mui/icons-material";

import useCompanySettings from "../hooks/useSettings/companySettings";
import { SOCKET_EVENTS } from "@markedesk/core-contracts";

const useStyles = makeStyles((theme) => ({
  listItem: {
    height: "44px",
    width: "auto",
    // Remove margin personalizada para manter alinhamento original
    "&:hover $iconHoverActive": {
      backgroundColor: theme.palette.primary.main, // Usa cor do tema
      color: "#fff",
      transform: "scale(1.05)",
    },
    "&:hover $listItemText": {
      color: theme.palette.primary.main, // Usa cor do tema
      fontWeight: 600,
    },
    // Transição suave
    transition: "all 0.3s ease",
  },

  listItemText: {
    fontSize: "14px",
    color: theme.mode === "light" ? "#666" : "#FFF",
    transition: "color 0.3s ease", // Só transição de cor
    fontWeight: 500,
    "& .MuiTypography-root": {
      fontFamily: "'Inter', 'Roboto', sans-serif",
    }
  },

  avatarActive: {
    backgroundColor: "transparent",
  },

  avatarHover: {
    backgroundColor: "transparent",
  },

  iconHoverActive: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%", // Mantém circular original
    height: 36, // Mantém tamanho original
    width: 36,  // Mantém tamanho original
    backgroundColor:
      theme.mode === "light"
        ? "rgba(120,120,120,0.1)"
        : "rgba(120,120,120,0.5)",
    color: theme.mode === "light" ? "#666" : "#FFF",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)", // Transição mais suave
    "&:hover, &.active": {
      backgroundColor: theme.palette.primary.main, // Usa cor do tema
      color: "#fff",
      boxShadow: `0 4px 12px ${theme.palette.primary.main}30`, // Sombra dinâmica
    },
    "& .MuiSvgIcon-root": {
      fontSize: "1.4rem", // Mantém tamanho original
      transition: "transform 0.3s ease",
    },
    "&:hover .MuiSvgIcon-root": {
      transform: "scale(1.1)", // Pequena animação no hover
    }
  },

  // Badge melhorado mas mantendo funcionalidade
  badge: {
    "& .MuiBadge-badge": {
      backgroundColor: "#ef4444",
      color: "#fff",
      fontSize: "0.75rem",
      fontWeight: 600,
      animation: "$pulse 2s infinite",
    }
  },

  "@keyframes pulse": {
    "0%, 100%": {
      opacity: 1,
    },
    "50%": {
      opacity: 0.7,
    }
  },

  // Melhorias para submenus mantendo estrutura original
  submenuContainer: {
    backgroundColor: theme.mode === "light"
      ? "rgba(0, 0, 0, 0.02)"
      : "rgba(255, 255, 255, 0.02)",
  },

  // Tooltip melhorado
  customTooltip: {
    backgroundColor: theme.mode === "light" ? "#1e293b" : "#374151",
    color: "#fff",
    fontSize: "0.875rem",
    fontWeight: 500,
    borderRadius: "8px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
    "& .MuiTooltip-arrow": {
      color: theme.mode === "light" ? "#1e293b" : "#374151",
    }
  },

  // Versão com destaque sutil
  versionContainer: {
    textAlign: "center",
    padding: "10px",
    color: theme.palette.primary.main, // Usa cor do tema
    fontSize: "12px",
    fontWeight: "bold",
    borderTop: `1px solid ${theme.mode === "light" ? "#f0f0f0" : "#333"}`,
    marginTop: "auto",
  },

  // Seções de administração com destaque sutil
  adminSection: {
    "& .MuiListSubheader-root": {
      color: theme.palette.primary.main, // Usa cor do tema
      fontSize: "0.875rem",
      fontWeight: 600,
      textTransform: "uppercase",
      letterSpacing: "0.5px",
    }
  },

  // Efeitos suaves para expand/collapse
  expandIcon: {
    transition: "transform 0.3s ease",
    color: theme.palette.primary.main, // Usa cor do tema
    "&.expanded": {
      transform: "rotate(180deg)",
    }
  },

  // Menu container com melhorias sutis
  menuContainer: {
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "6px",
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
      background: theme.mode === "light"
        ? "rgba(0, 0, 0, 0.1)"
        : "rgba(255, 255, 255, 0.1)",
      borderRadius: "3px",
      "&:hover": {
        background: theme.mode === "light"
          ? "rgba(0, 0, 0, 0.2)"
          : "rgba(255, 255, 255, 0.2)",
      }
    },
  },

  // Estado ativo melhorado mantendo funcionalidade original
  activeItem: {
    "& $iconHoverActive": {
      backgroundColor: theme.palette.primary.main, // Usa cor do tema
      color: "#fff",
    },
    "& $listItemText": {
      color: theme.palette.primary.main, // Usa cor do tema
      fontWeight: 700,
    }
  }
}));

function ListItemLink(props) {
  const { icon, primary, to, href, tooltip, showBadge, isNew } = props;
  const classes = useStyles();
  const { activeMenu } = useActiveMenu();
  const location = useLocation();
  const isActive = activeMenu === to || location.pathname === to;

  const hasBadge = showBadge || isNew;

  const renderLink = React.useMemo(
    () =>
      React.forwardRef((itemProps, ref) =>
        href ? (
          // Link cujo destino proíbe ser embutido (X-Frame-Options) — vai direto
          // para uma aba nova, sem passar pela tela do iframe só para descobrir
          // que não carrega.
          <a href={href} target="_blank" rel="noopener noreferrer" ref={ref} {...itemProps} />
        ) : (
          <RouterLink to={to} ref={ref} {...itemProps} />
        )
      ),
    [to, href]
  );

  const ConditionalTooltip = ({ children, tooltipEnabled }) =>
    tooltipEnabled ? (
      <Tooltip title={primary} placement="right">
        {children}
      </Tooltip>
    ) : (
      children
    );

  return (
    <ConditionalTooltip tooltipEnabled={!!tooltip}>
      <li>
        <ListItem button component={renderLink} className={classes.listItem}>
          {icon ? (
            <ListItemIcon>
              {hasBadge ? (
                <Badge
                  badgeContent={isNew ? i18n.t("badges.new") : "!"}
                  color={isNew ? "secondary" : "error"}
                  overlap="circular"
                  className={classes.badge}
                >
                  <Avatar
                    className={`${classes.iconHoverActive} ${isActive ? "active" : ""
                      }`}
                  >
                    {icon}
                  </Avatar>
                </Badge>
              ) : (
                <Avatar
                  className={`${classes.iconHoverActive} ${isActive ? "active" : ""
                    }`}
                >
                  {icon}
                </Avatar>
              )}
            </ListItemIcon>
          ) : null}
          <ListItemText
            primary={
              <Typography className={classes.listItemText}>
                {primary}
                {isNew && <NewBadge />}
              </Typography>
            }
          />
        </ListItem>
      </li>
    </ConditionalTooltip>
  );
}

const reducer = (state, action) => {
  if (action.type === "LOAD_CHATS") {
    const chats = action.payload;
    const newChats = [];

    if (isArray(chats)) {
      chats.forEach((chat) => {
        const chatIndex = state.findIndex((u) => u.id === chat.id);
        if (chatIndex !== -1) {
          state[chatIndex] = chat;
        } else {
          newChats.push(chat);
        }
      });
    }

    return [...state, ...newChats];
  }

  if (action.type === "UPDATE_CHATS") {
    const chat = action.payload;
    const chatIndex = state.findIndex((u) => u.id === chat.id);

    if (chatIndex !== -1) {
      state[chatIndex] = chat;
      return [...state];
    } else {
      return [chat, ...state];
    }
  }

  if (action.type === "DELETE_CHAT") {
    const chatId = action.payload;

    const chatIndex = state.findIndex((u) => u.id === chatId);
    if (chatIndex !== -1) {
      state.splice(chatIndex, 1);
    }
    return [...state];
  }

  if (action.type === "RESET") {
    return [];
  }

  if (action.type === "CHANGE_CHAT") {
    const changedChats = state.map((chat) => {
      if (chat.id === action.payload.chat.id) {
        return action.payload.chat;
      }
      return chat;
    });
    return changedChats;
  }
};

const MainListItems = ({ collapsed, drawerClose }) => {
  const theme = useTheme();
  const classes = useStyles();
  const { whatsApps } = useContext(WhatsAppsContext);
  const { user, socket } = useContext(AuthContext);

  const { setActiveMenu } = useActiveMenu();
  const location = useLocation();

  const [connectionWarning, setConnectionWarning] = useState(false);
  const [openCampaignSubmenu, setOpenCampaignSubmenu] = useState(false);
  const [openDashboardSubmenu, setOpenDashboardSubmenu] = useState(false);
  const [showCampaigns, setShowCampaigns] = useState(false);
  const [showKanban, setShowKanban] = useState(false);
  const [showWavoipCall, setShowWavoipCall] = useState(false);

  // novas features
  const [showSchedules, setShowSchedules] = useState(false);
  const [showInternalChat, setShowInternalChat] = useState(false);
  const [showExternalApi, setShowExternalApi] = useState(false);

  const [invisible, setInvisible] = useState(true);
  const [pageNumber, setPageNumber] = useState(1);
  const [searchParam] = useState("");
  const [chats, dispatch] = useReducer(reducer, []);
  const [version, setVersion] = useState(false);
  const [managementHover, setManagementHover] = useState(false);
  const [campaignHover, setCampaignHover] = useState(false);
  const { list } = useHelps(); // INSERIR
  const [hasHelps, setHasHelps] = useState(false);
  // #4457 — Termos de Uso para visualização por qualquer usuário.
  const [openTermsModal, setOpenTermsModal] = useState(false);

  const [openFlowSubmenu, setOpenFlowSubmenu] = useState(false);
  const [flowHover, setFlowHover] = useState(false);

  const { get: getSetting } = useCompanySettings();
  const [showWallets, setShowWallets] = useState(false);

  // External Links
  const [externalLinks, setExternalLinks] = useState([]);

  const isFlowbuilderRouteActive =
    location.pathname.startsWith("/phrase-lists");
  location.pathname.startsWith("/flowbuilders");

  useEffect(() => {
    // INSERIR ESSE EFFECT INTEIRO
    async function checkHelps() {
      const helps = await list();
      setHasHelps(helps.length > 0);
    }
    checkHelps();
  }, []);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const setting = await getSetting(
          {
            "column": "DirectTicketsToWallets"
          }
        );

        setShowWallets(setting.DirectTicketsToWallets);

      } catch (err) {
        toastError(err);
      }
    }

    fetchSettings();
  }, [setShowWallets]);

  // Fetch external links for menu
  useEffect(() => {
    const fetchExternalLinks = async () => {
      try {
        const { data } = await api.get("/company-external-links/menu");
        setExternalLinks(data);
      } catch (err) {
        // Silently fail - external links are optional
        console.log("External links not available");
      }
    };

    if (user?.companyId) {
      fetchExternalLinks();
    }
  }, [user?.companyId]);

  const isManagementActive =
    location.pathname === "/" ||
    location.pathname.startsWith("/reports") ||
    location.pathname.startsWith("/moments");

  const isCampaignRouteActive =
    location.pathname === "/campaigns" ||
    location.pathname.startsWith("/contact-lists") ||
    location.pathname.startsWith("/campaigns-config");

  useEffect(() => {
    if (location.pathname.startsWith("/tickets")) {
      setActiveMenu("/tickets");
    } else {
      setActiveMenu("");
    }
  }, [location, setActiveMenu]);

  const { getPlanCompany } = usePlans();

  const { getVersion } = useVersion();

  useEffect(() => {
    async function fetchVersion() {
      const _version = await getVersion();
      setVersion(_version.version);
    }
    fetchVersion();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch({ type: "RESET" });
    setPageNumber(1);
  }, [searchParam]);

  useEffect(() => {
    async function fetchData() {
      const companyId = user.companyId;
      const planConfigs = await getPlanCompany(undefined, companyId);

      setShowCampaigns(planConfigs.plan.useCampaigns);
      setShowKanban(planConfigs.plan.useKanban);
      setShowSchedules(planConfigs.plan.useSchedules);
      setShowInternalChat(planConfigs.plan.useInternalChat);
      setShowExternalApi(planConfigs.plan.useExternalApi);
      setShowWavoipCall(planConfigs.plan.wavoip);
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      fetchChats();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParam, pageNumber]);

  useEffect(() => {
    if (user.id && socket && typeof socket.on === 'function') {
      const onCompanyChatMainListItems = (data) => {
        if (data.action === "new-message") {
          dispatch({ type: "CHANGE_CHAT", payload: data });
        }
        if (data.action === "update") {
          dispatch({ type: "CHANGE_CHAT", payload: data });
        }
      };

      const eventName = SOCKET_EVENTS.CHAT.LIST;
      console.log('Registrando listener para:', eventName);

      socket.on(eventName, onCompanyChatMainListItems);

      return () => {
        if (socket && typeof socket.off === 'function') {
          console.log('Removendo listener para:', eventName);
          socket.off(eventName, onCompanyChatMainListItems);
        }
      };
    }
  }, [socket, user.id, user.companyId]);

  useEffect(() => {
    let unreadsCount = 0;
    if (chats.length > 0) {
      for (let chat of chats) {
        for (let chatUser of chat.users) {
          if (chatUser.userId === user.id) {
            unreadsCount += chatUser.unreads;
          }
        }
      }
    }
    if (unreadsCount > 0) {
      setInvisible(false);
    } else {
      setInvisible(true);
    }
  }, [chats, user.id]);

  // useEffect(() => {
  //   if (localStorage.getItem("cshow")) {
  //     setShowCampaigns(true);
  //   }
  // }, []);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (whatsApps.length > 0) {
        const offlineWhats = whatsApps.filter((whats) => {
          return (
            whats.status === "qrcode" ||
            whats.status === "PAIRING" ||
            whats.status === "DISCONNECTED" ||
            whats.status === "TIMEOUT" ||
            whats.status === "OPENING"
          );
        });
        if (offlineWhats.length > 0) {
          setConnectionWarning(true);
        } else {
          setConnectionWarning(false);
        }
      }
    }, 2000);
    return () => clearTimeout(delayDebounceFn);
  }, [whatsApps]);

  const fetchChats = async () => {
    try {
      const { data } = await api.get("/chats/", {
        params: { searchParam, pageNumber },
      });
      dispatch({ type: "LOAD_CHATS", payload: data.records });
    } catch (err) {
      toastError(err);
    }
  };

  // Map icon name to component
  const getIconComponent = (iconName) => {
    const iconMap = {
      // Básicos
      Link: <LinkIcon />,
      Dashboard: <Dashboard />,
      Home: <HomeIcon />,
      Settings: <SettingsOutlinedIcon />,
      Search: <SearchIcon />,
      Language: <LanguageIcon />,
      Public: <PublicIcon />,
      OpenInNew: <OpenInNewIcon />,
      Launch: <LaunchIcon />,

      // Negócios e Finanças
      Business: <BusinessIconExt />,
      Work: <WorkIcon />,
      AccountBalance: <AccountBalanceIcon />,
      LocalAtm: <LocalAtmIconExt />,
      AttachMoney: <AttachMoneyIcon />,
      CreditCard: <CreditCardIcon />,
      Receipt: <ReceiptIcon />,
      ShoppingCart: <ShoppingCartIcon />,
      ShoppingBasket: <ShoppingBasketIcon />,
      Store: <StoreIcon />,
      Storefront: <StorefrontIcon />,
      LocalMall: <LocalMallIcon />,
      LocalShipping: <LocalShippingIcon />,
      Category: <CategoryIcon />,
      LocalOffer: <LocalOfferIcon />,
      Loyalty: <LoyaltyIcon />,
      CardGiftcard: <CardGiftcardIcon />,

      // Gráficos e Relatórios
      Assessment: <AssessmentIcon />,
      BarChart: <BarChartIcon />,
      PieChart: <PieChartIcon />,
      Timeline: <TimelineIcon />,
      TrendingUp: <TrendingUpIcon />,
      InsertChart: <InsertChartIcon />,
      ShowChart: <ShowChartIcon />,
      TableChart: <TableChartIcon />,

      // Pessoas e Contatos
      People: <PeopleExtIcon />,
      Group: <GroupIcon />,
      AccountCircle: <AccountCircleIcon />,
      PersonAdd: <PersonAddIcon />,
      Contacts: <ContactsIcon />,
      ContactMail: <ContactMailIcon />,
      ContactPhone: <ContactPhoneIcon />,

      // Comunicação
      Email: <EmailIcon />,
      Phone: <PhoneIcon />,
      Chat: <ChatIcon />,
      Notifications: <NotificationsIcon />,
      Campaign: <AnnouncementIconExt />,
      Announcement: <AnnouncementIconExt />,
      Headset: <HeadsetIcon />,
      HeadsetMic: <HeadsetMicIcon />,

      // Documentos e Arquivos
      Description: <Description />,
      Assignment: <AssignmentIcon />,
      AssignmentTurnedIn: <AssignmentTurnedInIcon />,
      Folder: <FolderIcon />,
      FolderOpen: <FolderOpenIcon />,
      FolderShared: <FolderSharedIcon />,
      CreateNewFolder: <CreateNewFolderIcon />,
      FileCopy: <FileCopyIcon />,
      AttachFile: <AttachFile />,
      Save: <SaveIcon />,
      SaveAlt: <SaveAltIcon />,
      GetApp: <GetAppIcon />,
      Publish: <PublishIcon />,

      // Agenda e Tempo
      Event: <EventIcon />,
      EventNote: <EventNoteIcon />,
      CalendarToday: <CalendarTodayIcon />,
      DateRange: <DateRangeIcon />,
      Today: <TodayIcon />,
      Schedule: <Schedule />,
      AccessTime: <AccessTimeIcon />,
      Alarm: <AlarmIcon />,
      Timer: <TimerIcon />,
      History: <HistoryIcon />,
      Update: <UpdateIcon />,

      // Localização
      Map: <MapIcon />,
      Place: <PlaceIcon />,
      LocationOn: <LocationOnIcon />,
      Navigation: <NavigationIcon />,
      Explore: <ExploreIcon />,
      Flag: <FlagIcon />,
      DirectionsCar: <DirectionsCarIcon />,
      Flight: <FlightIcon />,

      // Saúde
      LocalHospital: <LocalHospitalIcon />,
      LocalPharmacy: <LocalPharmacyIcon />,
      Healing: <HealingIcon />,
      FitnessCenter: <FitnessCenterIcon />,

      // Alimentação
      Restaurant: <RestaurantIcon />,
      LocalCafe: <LocalCafeIcon />,
      Fastfood: <FastfoodIcon />,

      // Segurança
      Security: <SecurityIcon />,
      Lock: <LockIcon />,
      VpnKey: <VpnKeyIcon />,
      VerifiedUser: <VerifiedUserIcon />,
      Policy: <PolicyIcon />,
      Gavel: <GavelIcon />,

      // Status e Feedback
      CheckCircle: <CheckCircleIcon />,
      Cancel: <CancelIcon />,
      Error: <ErrorIcon />,
      Warning: <WarningIcon />,
      Info: <InfoIcon />,
      Help: <HelpOutlineIcon />,
      Report: <ReportIcon />,
      Block: <BlockIcon />,
      ThumbUp: <ThumbUpIcon />,
      ThumbDown: <ThumbDownIcon />,

      // Favoritos e Destaques
      Favorite: <FavoriteIcon />,
      Star: <StarIcon />,
      Bookmark: <BookmarkIcon />,
      Grade: <GradeIcon />,
      EmojiEvents: <EmojiEventsIcon />,

      // Tecnologia
      Code: <CodeIcon />,
      DeveloperMode: <DeveloperModeIcon />,
      BugReport: <BugReportIcon />,
      Extension: <ExtensionIcon />,
      Widgets: <WidgetsIcon />,
      Apps: <AppsIcon />,
      Memory: <MemoryIcon />,

      // Dispositivos
      Computer: <ComputerIcon />,
      Laptop: <LaptopIcon />,
      PhoneAndroid: <PhoneAndroidIcon />,
      Tablet: <TabletIcon />,
      Watch: <WatchIcon />,
      Tv: <TvIcon />,
      Print: <PrintIcon />,
      Router: <RouterIcon />,
      Wifi: <WifiIcon />,
      Bluetooth: <BluetoothIcon />,
      Cast: <CastIcon />,
      Mouse: <MouseIcon />,
      Keyboard: <KeyboardIcon />,

      // Cloud e Storage
      Cloud: <CloudIcon />,
      CloudUpload: <CloudUploadIcon />,
      CloudDownload: <CloudDownloadIcon />,
      CloudDone: <CloudDoneIcon />,
      Backup: <BackupIcon />,
      Restore: <RestoreIcon />,
      Storage: <StorageIcon />,
      Dns: <DnsIcon />,
      Sync: <SyncIcon />,
      Refresh: <RefreshIcon />,

      // Mídia
      Image: <ImageIcon />,
      PhotoCamera: <PhotoCameraIcon />,
      Videocam: <VideocamIcon />,
      Mic: <MicIcon />,
      MusicNote: <MusicNoteIcon />,
      Movie: <MovieIcon />,
      PlayArrow: <PlayArrowIcon />,
      Pause: <PauseIcon />,
      Stop: <StopIcon />,
      SkipNext: <SkipNextIcon />,
      SkipPrevious: <SkipPreviousIcon />,
      VolumeUp: <VolumeUpIcon />,

      // Educação
      School: <SchoolIcon />,

      // Design e Visual
      Palette: <PaletteIcon />,
      Brush: <BrushIcon />,
      ColorLens: <ColorLensIcon />,
      FormatPaint: <FormatPaintIcon />,
      TextFields: <TextFieldsIcon />,
      Brightness4: <Brightness4Icon />,

      // Natureza e Clima
      WbSunny: <WbSunnyIcon />,
      NightsStay: <NightsStayIcon />,
      Eco: <EcoIcon />,
      Nature: <NatureIcon />,
      Pets: <PetsIcon />,
      FlashOn: <FlashOnIcon />,
      Whatshot: <WhatshotIcon />,

      // Ações e Interface
      Build: <BuildIcon />,
      Visibility: <VisibilityIcon />,
      ExitToApp: <ExitToAppIcon />,
      PowerSettingsNew: <PowerSettingsNewIcon />,
      MoreVert: <MoreVertIcon />,
      MoreHoriz: <MoreHorizIcon />,
      FilterList: <FilterListIcon />,
      Sort: <SortIcon />,
      List: <ListIconMUI />,
      FormatListBulleted: <FormatListBulletedIcon />,
      PlaylistAdd: <PlaylistAddIcon />,
      Queue: <QueueIcon />,
      ViewModule: <ViewModuleIcon />,
      ViewList: <ViewListIcon />,
      ViewQuilt: <ViewQuiltIcon />,

      // Redes Sociais
      Facebook: <FacebookIcon />,
      Twitter: <TwitterIcon />,
      Instagram: <InstagramIcon />,
      LinkedIn: <LinkedInIcon />,
      YouTube: <YouTubeIcon />,
      WhatsApp: <WhatsAppIcon />,
      Telegram: <TelegramIcon />,
      GitHub: <GitHubIcon />,
      Android: <AndroidIcon />,
      Apple: <AppleIcon />,
    };
    return iconMap[iconName] || <LinkIcon />;
  };

  const isExternalLinksRouteActive = location.pathname.startsWith("/external-link");

  return (
    <div onClick={drawerClose}>
      <Can
        role={
          (user.profile === "user" && user.showDashboard === "enabled") ||
            user.allowRealTime === "enabled"
            ? "admin"
            : user.profile
        }
        perform={"drawer-admin-items:view"}
        yes={() => (
          <>
            <Tooltip
              title={collapsed ? i18n.t("mainDrawer.listItems.management") : ""}
              placement="right"
            >
              <ListItem
                dense
                button
                onClick={() => setOpenDashboardSubmenu((prev) => !prev)}
                onMouseEnter={() => setManagementHover(true)}
                onMouseLeave={() => setManagementHover(false)}
              >
                <ListItemIcon>
                  <Avatar
                    className={`${classes.iconHoverActive} ${isManagementActive || managementHover ? "active" : ""
                      }`}
                  >
                    <Dashboard />
                  </Avatar>
                </ListItemIcon>
                <ListItemText
                  primary={
                    <Typography className={classes.listItemText}>
                      {i18n.t("mainDrawer.listItems.management")}
                    </Typography>
                  }
                />
                {openDashboardSubmenu ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </ListItem>
            </Tooltip>
            <Collapse
              in={openDashboardSubmenu}
              timeout="auto"
              unmountOnExit
              style={{
                backgroundColor:
                  theme.mode === "light"
                    ? "rgba(120,120,120,0.1)"
                    : "rgba(120,120,120,0.5)",
              }}
            >
              <Can
                role={
                  user.profile === "user" && user.showDashboard === "enabled"
                    ? "admin"
                    : user.profile
                }
                perform={"drawer-admin-items:view"}
                yes={() => (
                  <>
                    <ListItemLink
                      small
                      to="/"
                      primary="Dashboard"
                      icon={<DashboardOutlinedIcon />}
                      tooltip={collapsed}
                    />
                    <ListItemLink
                      small
                      to="/reports"
                      primary={i18n.t("mainDrawer.listItems.reports")}
                      icon={<Description />}
                      tooltip={collapsed}
                    />
                  </>
                )}
              />
              <Can
                role={
                  user.profile === "user" && user.allowRealTime === "enabled"
                    ? "admin"
                    : user.profile
                }
                perform={"drawer-admin-items:view"}
                yes={() => (
                  <ListItemLink
                    to="/moments"
                    primary={i18n.t("mainDrawer.listItems.chatsTempoReal")}
                    icon={<GridOn />}
                    tooltip={collapsed}
                  />
                )}
              />
              {user.profile === "admin" && showWallets && (
                <>
                  <ListItemLink
                    to="/wallets"
                    primary={i18n.t("mainDrawer.listItems.wallets")}
                    icon={<AccountBalanceWalletIcon />}
                    tooltip={collapsed}
                  />
                </>
              )}
            </Collapse>
          </>
        )}
      />
      <ListItemLink
        to="/tickets"
        primary={i18n.t("mainDrawer.listItems.tickets")}
        icon={<WhatsAppIcon />}
        tooltip={collapsed}
      />

      {showWavoipCall && (
        <ListItemLink
          to="/call-historicals"
          primary={i18n.t("mainDrawer.listItems.callHistorical")}
          icon={<HistoryToggleOffIcon />}
          tooltip={collapsed}
        />
      )}

      <ListItemLink
        to="/quick-messages"
        primary={i18n.t("mainDrawer.listItems.quickMessages")}
        icon={<FlashOnIcon />}
        tooltip={collapsed}
      />

      {showKanban && (
        <>
          <ListItemLink
            to="/kanban"
            primary={i18n.t("mainDrawer.listItems.kanban")}
            icon={<ViewKanban />}
            tooltip={collapsed}
          />
        </>
      )}

      {user.showContacts === "enabled" && (
        <ListItemLink
          to="/contacts"
          primary={i18n.t("mainDrawer.listItems.contacts")}
          icon={<ContactPhoneOutlinedIcon />}
          tooltip={collapsed}
        />
      )}

      {showSchedules && (
        <>
          <ListItemLink
            to="/schedules"
            primary={i18n.t("mainDrawer.listItems.schedules")}
            icon={<Schedule />}
            tooltip={collapsed}
          />
        </>
      )}

      <ListItemLink
        to="/tags"
        primary={i18n.t("mainDrawer.listItems.tags")}
        icon={<LocalOfferIcon />}
        tooltip={collapsed}
      />

      <ListItemLink
        to="/tasks"
        primary={i18n.t("mainDrawer.listItems.tasks")}
        icon={<AssignmentIcon />}
        tooltip={collapsed}
      />

      {showInternalChat && (
        <>
          <ListItemLink
            to="/chats"
            primary={i18n.t("mainDrawer.listItems.chats")}
            icon={
              <Badge color="secondary" variant="dot" invisible={invisible}>
                <ForumIcon />
              </Badge>
            }
            tooltip={collapsed}
          />
        </>
      )}

      {/* 
      <ListItemLink
        to="/todolist"
        primary={i18n.t("ToDoList")}
        icon={<EventAvailableIcon />}
      /> 
      */}

      {hasHelps && (
        <ListItemLink
          to="/helps"
          primary={i18n.t("mainDrawer.listItems.helps")}
          icon={<HelpOutlineIcon />}
          tooltip={collapsed}
        />
      )}


      {user?.showCampaign === "enabled" && showCampaigns && (
        <>
          <Tooltip
            title={collapsed ? i18n.t("mainDrawer.listItems.campaigns") : ""}
            placement="right"
          >
            <ListItem
              dense
              button
              onClick={() => setOpenCampaignSubmenu((prev) => !prev)}
              onMouseEnter={() => setCampaignHover(true)}
              onMouseLeave={() => setCampaignHover(false)}
            >
              <ListItemIcon>
                <Avatar
                  className={`${classes.iconHoverActive} ${isCampaignRouteActive || campaignHover ? "active" : ""}`}
                >
                  <EventAvailableIcon />
                </Avatar>
              </ListItemIcon>
              <ListItemText
                primary={
                  <Typography className={classes.listItemText}>
                    {i18n.t("mainDrawer.listItems.campaigns")}
                  </Typography>
                }
              />
              {openCampaignSubmenu ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </ListItem>
          </Tooltip>
          <Collapse
            in={openCampaignSubmenu}
            timeout="auto"
            unmountOnExit
            style={{
              backgroundColor:
                theme.mode === "light"
                  ? "rgba(120,120,120,0.1)"
                  : "rgba(120,120,120,0.5)",
            }}
          >
            <List dense component="div" disablePadding>
              <ListItemLink
                to="/campaigns"
                primary={i18n.t("campaigns.subMenus.list")}
                icon={<ListIcon />}
                tooltip={collapsed}
              />
              <ListItemLink
                to="/contact-lists"
                primary={i18n.t("campaigns.subMenus.listContacts")}
                icon={<PeopleIcon />}
                tooltip={collapsed}
              />
              <ListItemLink
                to="/campaigns-config"
                primary={i18n.t("campaigns.subMenus.settings")}
                icon={<SettingsOutlinedIcon />}
                tooltip={collapsed}
              />
              <Can
                role={user.profile}
                perform="dashboard:view"
                yes={() => (
                  <ListItemLink
                    to="/files"
                    primary={i18n.t("mainDrawer.listItems.files")}
                    icon={<AttachFile />}
                    tooltip={collapsed}
                  />
                )}
              />
            </List>
          </Collapse>
        </>
      )}

      {/* FLOWBUILDER */}
      {user.showFlow === "enabled" && (
        <>
          <Tooltip
            title={
              collapsed ? i18n.t("mainDrawer.listItems.campaigns") : ""
            }
            placement="right"
          >
            <ListItem
              dense
              button
              onClick={() => setOpenFlowSubmenu((prev) => !prev)}
              onMouseEnter={() => setFlowHover(true)}
              onMouseLeave={() => setFlowHover(false)}
            >
              <ListItemIcon>
                <Avatar
                  className={`${classes.iconHoverActive} ${isFlowbuilderRouteActive || flowHover
                    ? "active"
                    : ""
                    }`}
                >
                  <Webhook />
                </Avatar>
              </ListItemIcon>
              <ListItemText
                primary={
                  <Typography className={classes.listItemText}>
                    {i18n.t("Flowbuilder")}
                  </Typography>
                }
              />
              {openFlowSubmenu ? (
                <ExpandLessIcon />
              ) : (
                <ExpandMoreIcon />
              )}
            </ListItem>
          </Tooltip>

          <Collapse
            in={openFlowSubmenu}
            timeout="auto"
            unmountOnExit
            style={{
              backgroundColor:
                theme.mode === "light"
                  ? "rgba(120,120,120,0.1)"
                  : "rgba(120,120,120,0.5)",
            }}
          >
            <List dense component="div" disablePadding>
              <ListItemLink
                to="/phrase-lists"
                primary={"Fluxo de Campanha"}
                icon={<EventAvailableIcon />}
                tooltip={collapsed}
              />

              <ListItemLink
                to="/flowbuilders"
                primary={"Fluxo de conversa"}
                icon={<ShapeLine />}
              />
            </List>
          </Collapse>
        </>
      )}

      {/* #4457 — Termos de Uso: visível a qualquer usuário, logo abaixo do Flowbuilder. */}
      <Tooltip
        title={collapsed ? i18n.t("mainDrawer.listItems.termsOfUse") : ""}
        placement="right"
      >
        <ListItem
          button
          dense
          onClick={() => setOpenTermsModal(true)}
          className={classes.listItem}
        >
          <ListItemIcon>
            <Avatar className={classes.iconHoverActive}>
              <Description />
            </Avatar>
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography className={classes.listItemText}>
                {i18n.t("mainDrawer.listItems.termsOfUse")}
              </Typography>
            }
          />
        </ListItem>
      </Tooltip>

      {/* External Links - Links Externos Customizados */}
      {externalLinks.length > 0 && (
        <>
          <Divider />
          <ListSubheader inset>
            {i18n.t("mainDrawer.listItems.externalLinks")}
          </ListSubheader>
          {externalLinks.map((link) => (
            <ListItemLink
              key={link.id}
              to={`/external-link/${link.id}`}
              href={link.openMode === "new_tab" ? link.url : undefined}
              primary={link.name}
              icon={getIconComponent(link.icon)}
              tooltip={collapsed}
            />
          ))}
        </>
      )}

      <Can
        role={
          user.profile === "user" && user.allowConnections === "enabled"
            ? "admin"
            : user.profile
        }
        perform="dashboard:view"
        yes={() => (
          <>
            <Divider />
            <ListSubheader inset>
              {i18n.t("mainDrawer.listItems.administration")}
            </ListSubheader>

            {user.super && (
              <ListItemLink
                to="/announcements"
                primary={i18n.t("mainDrawer.listItems.annoucements")}
                icon={<AnnouncementIcon />}
                tooltip={collapsed}
              />
            )}

            {showExternalApi && (
              <>
                <Can
                  role={user.profile}
                  perform="dashboard:view"
                  yes={() => (
                    <ListItemLink
                      to="/messages-api"
                      primary={i18n.t("mainDrawer.listItems.messagesAPI")}
                      icon={<CodeRoundedIcon />}
                      tooltip={collapsed}
                    />
                  )}
                />
              </>
            )}

            <Can
              role={user.profile}
              perform="dashboard:view"
              yes={() => (
                <ListItemLink
                  to="/users"
                  primary={i18n.t("mainDrawer.listItems.users")}
                  icon={<PeopleAltOutlinedIcon />}
                  tooltip={collapsed}
                />
              )}
            />

            <Can
              role={user.profile}
              perform="dashboard:view"
              yes={() => (
                <ListItemLink
                  to="/audit-logs"
                  primary={i18n.t("mainDrawer.listItems.auditLogs")}
                  icon={<HistoryIcon />}
                  tooltip={collapsed}
                  isNew
                />
              )}
            />

            <Can
              role={user.profile}
              perform="dashboard:view"
              yes={() => (
                <ListItemLink
                  to="/consumption"
                  primary={i18n.t("companyUsage.page.title")}
                  icon={<EqualizerIcon />}
                  tooltip={collapsed}
                />
              )}
            />

            <Can
              role={user.profile}
              perform="dashboard:view"
              yes={() => (
                <ListItemLink
                  to="/birthday-settings"
                  primary={i18n.t("mainDrawer.listItems.birthdaySettings")}
                  icon={<CakeIcon />}
                  tooltip={collapsed}
                />
              )}
            />

            <Can
              role={user.profile}
              perform="dashboard:view"
              yes={() => (
                <ListItemLink
                  to="/queues"
                  primary={i18n.t("mainDrawer.listItems.queues")}
                  icon={<AccountTreeOutlinedIcon />}
                  tooltip={collapsed}
                />
              )}
            />


            <Can
              role={
                user.profile === "user" && user.allowConnections === "enabled"
                  ? "admin"
                  : user.profile
              }
              perform={"drawer-admin-items:view"}
              yes={() => (
                <ListItemLink
                  to="/connections"
                  primary={i18n.t("mainDrawer.listItems.connections")}
                  icon={<SyncAltIcon />}
                  showBadge={connectionWarning}
                  tooltip={collapsed}
                />
              )}
            />
            <Can
              role={
                user.profile === "user" && user.allowConnections === "enabled"
                  ? "admin"
                  : user.profile
              }
              perform={"drawer-admin-items:view"}
              yes={() => (
                <ListItemLink
                  to="/plugins"
                  primary="Plugins"
                  icon={<ExtensionIcon />}
                  tooltip={collapsed}
                  isNew
                />
              )}
            />
            {/* Itens de menu adicionados por plugins (slot sidebar-menu) */}
            <PluginSidebarItems collapsed={collapsed} />
            {user.super && (
              <ListItemLink
                to="/allConnections"
                primary={i18n.t("mainDrawer.listItems.allConnections")}
                icon={<PhonelinkSetup />}
                tooltip={collapsed}
              />
            )}
            <Can
              role={user.profile}
              perform="dashboard:view"
              yes={() => (
                <ListItemLink
                  to="/financeiro"
                  primary={i18n.t("mainDrawer.listItems.financeiro")}
                  icon={<LocalAtmIcon />}
                  tooltip={collapsed}
                />
              )}
            />
            <Can
              role={user.profile}
              perform="dashboard:view"
              yes={() => (
                <ListItemLink
                  to="/settings"
                  primary={i18n.t("mainDrawer.listItems.settings")}
                  icon={<SettingsOutlinedIcon />}
                  tooltip={collapsed}
                />
              )}
            />
          </>
        )}
      />

      {!collapsed && (
        <React.Fragment>
          <Divider />
          <Typography
            style={{
              fontSize: "12px",
              padding: "10px",
              textAlign: "center",
              fontWeight: "bold",
            }}
          >
            {`${version}`}
          </Typography>
        </React.Fragment>
      )}

      <TermsOfUseModal
        open={openTermsModal}
        onClose={() => setOpenTermsModal(false)}
      />
    </div>
  );
};

export default MainListItems;